import { SearchTermHighlight } from 'components/SearchTermHighlight';
import React from 'react';
import { displayName, NamedEntityParts, useLastNameFirst } from 'utils/nameOrder';
import VacationMarker from './VacationMarker';

interface EmployeeNameProps {
    entity: NamedEntityParts;
}

/**
 * Renders an employee/person display name, flipped to "Last First" under the LAST_NAME_FIRST flag
 * when the entity carries both first and last name, otherwise the pre-joined `name`. Text only —
 * the employee analog of `<PartyName>` for the many sites that show `employee.name` as raw text or
 * inside their own link/chip. Wrap it in a link or other markup at the call site.
 *
 * On-vacation employees (VACATION_DECLARER) get the palm-tree marker with its tooltip prefixed; the
 * name is formatted with the marker suppressed so the palm isn't also baked into the string.
 */
const EmployeeName: React.FC<EmployeeNameProps> = ({ entity }) => {
    const lastNameFirst = useLastNameFirst();
    return (
        <>
            <VacationMarker onVacation={entity.onVacation} />
            <SearchTermHighlight text={displayName({ ...entity, onVacation: false }, lastNameFirst)} />
        </>
    );
};

export default EmployeeName;
